import { CSSProperties, JSX, SVGProps } from "react";

export interface IconStorage {
  svgCode: SvgCodeFunc;
  svgProps?: SVGProps<SVGSVGElement>,
}

export type SvgCodeFunc = (color?: string, pathStyle?: CSSProperties) => (JSX.Element | string[]);

export const sharedLineIconProps = (color: string = "currentColor", pathStyle: CSSProperties): React.SVGAttributes<SVGElement> => ({
  stroke: color,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  style: pathStyle,
});
